import ExistingCustomerVettingContainer from './containers/ExistingCustomerVettingContainer';

export default ExistingCustomerVettingContainer;
